import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.2568 5.05927C11.0214 3.69996 12.9785 3.69997 13.7431 5.05927L21.0333 18.0195C21.7832 19.3527 20.8198 21.0001 19.2901 21.0001H4.70982C3.18017 21.0001 2.21674 19.3527 2.96667 18.0195L10.2568 5.05927ZM12 6.03979L4.70982 19.0001L19.2901 19.0001L12 6.03979ZM11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V11ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.8504 11.6483L13.8504 11.6484C13.8694 11.6795 13.8701 11.697 13.87 11.7057C13.8698 11.7184 13.8658 11.7398 13.85 11.7658C13.8198 11.8154 13.7545 11.87 13.6351 11.87H3.36485C3.24545 11.87 3.18017 11.8154 3.15003 11.7658C3.1342 11.7398 3.13024 11.7184 3.13001 11.7057C3.12986 11.697 3.13057 11.6795 3.14956 11.6484L3.14963 11.6483L8.28471 3.23393L8.28478 3.23381C8.31767 3.18002 8.38593 3.13 8.5 3.13C8.61407 3.13 8.68233 3.18002 8.71522 3.23381L8.71529 3.23393L13.8504 11.6483ZM9.67979 2.64516L14.8149 11.0597C15.34 11.9199 14.6854 13 13.6351 13H3.36485C2.31464 13 1.65996 11.9199 2.18506 11.0597L7.32021 2.64516C7.84532 1.78495 9.15468 1.78495 9.67979 2.64516ZM8.50006 6C8.8121 6 9.06506 6.25296 9.06506 6.565V8.50006C9.06506 8.8121 8.8121 9.06506 8.50006 9.06506C8.18802 9.06506 7.93506 8.8121 7.93506 8.50006V6.565C7.93506 6.25296 8.18802 6 8.50006 6ZM9.07995 10.4649C9.07995 10.7769 8.82699 11.0299 8.51495 11.0299C8.20291 11.0299 7.94995 10.7769 7.94995 10.4649C7.94995 10.1529 8.20291 9.8999 8.51495 9.8999C8.82699 9.8999 9.07995 10.1529 9.07995 10.4649Z"
  />
);

export const WarningOutlineIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="WarningOutline" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
